import React, { FC } from 'react';
import './CopyLabelCellRenderer.scss';
import Icon from 'common/components/base/icon';
import { ICON_COLLECTION } from 'assets/media/icons';

type CopyLabelCellRendererProps = {
    value: string;
    className: string;
    valueFormatted?: string;
};

const CopyLabelCellRenderer: FC<CopyLabelCellRendererProps> = ({
    value,
    className,
    valueFormatted
}: CopyLabelCellRendererProps) => {
    return (
        <div className="copy-label-cell-renderer" title={valueFormatted || value}>
            <span className={`copy-label-cell-renderer__value`}>{valueFormatted || value}</span>
            <Icon
                className="copy-label-cell-renderer__copy-icon"
                title="Copy to clipboard"
                src={ICON_COLLECTION.IC_Copy}
                onClick={() => {
                    navigator.clipboard.writeText(value);
                }}
            />
        </div>
    );
};
export default CopyLabelCellRenderer;
